import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/es6.promise.js";
import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es7.promise.finally.js";
import Vue from 'vue';
import { Carousel, Slide } from 'vue-carousel';
Vue.component('mdmCarousel', Carousel);
Vue.component('mdmSlide', Slide);